import { loadOrt } from "@instacover/helpers"
import { getImgDataForTensor } from "@instacover/utils"
import type { Tensor } from "onnxruntime-web"

export async function imgToTensor(img: HTMLImageElement): Promise<Tensor> {
  const { Tensor: TensorCtor } = await loadOrt()
  const { values, dims } = getImgDataForTensor(img)
  return new TensorCtor(values, dims)
}
